import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-[#bfa360]">{children}</p>
);

export const SectionHead = ({ eyebrow, title, className = "", light = false }) => (
  <div className={className}>
    <Reveal>
      <div className="flex items-center gap-4 mb-6">
        <Eyebrow>{eyebrow}</Eyebrow>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-tight ${light ? "text-[#1c242f]" : "text-[#f4f2ea]"}`}>
        {title}
      </h2>
    </Reveal>
  </div>
);
